import {
  sliderBanner,
  sliderCustomerService,
  sliderGallery,
  sliderProductReasurance,
  sliderSimplePress,
  sliderSuggestProducts,
  slidersMobile,
} from './slider-swiper';

const initTabs = () => {
  if (window.innerWidth <= 768) {
    document.querySelectorAll('.accordion-head').forEach((item) => {
      item.addEventListener('click', () => {
        const panel = document.querySelector(`#${item.dataset.tab}`);
        item.classList.toggle('active');
        panel.classList.toggle('active');
      });
    });
  } else {
    const tabs = document.querySelectorAll('.tab-title');
    const tabInfos = document.querySelectorAll('.tab-content');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = document.querySelector(`#${tab.dataset.tab}`);
        tabInfos.forEach((tabInfo) => {
          tabInfo.classList.remove('active');
        });
        tabs.forEach((tabInfo) => {
          tabInfo.classList.remove('active');
        });
        target.classList.add('active');
        tab.classList.add('active');
      });
    });
  }
};

export const initProduct = () => {
  initTabs();

  // Sliders
  sliderGallery();
  sliderProductReasurance();
  sliderSuggestProducts();
  sliderCustomerService();
  sliderSimplePress();
  slidersMobile();
  sliderBanner();
};
